/**
 * Công nợ đơn hàng — quy ước dấu của backend (Order#recompute_debit_amount!):
 *   debit_amount = tổng đã thu - tổng phải thu
 *   âm  = khách còn nợ
 *   0   = đã thu đủ
 *   dương = đã thu THỪA (shop nợ lại khách)
 *
 * TUYỆT ĐỐI không dùng Math.abs(debit_amount) để tính số tiền cần thu: đơn thu thừa
 * sẽ bị biến thành một lệnh đòi tiền mới đúng bằng khoản đã thu thừa.
 * Sự cố production HD02410: khách quét lại mã QR cũ (2.980.800đ) sau khi đơn đã được
 * sửa xuống 2.689.200đ → thu thừa 291.600đ → modal hiện "cần thanh toán 291.600đ".
 */

/** Số tiền khách CÒN PHẢI TRẢ (0 nếu đã thu đủ hoặc thu thừa). */
export const outstandingAmount = (debitAmount?: number | null): number => {
  const debit = Number(debitAmount ?? 0);
  return debit < 0 ? Math.abs(debit) : 0;
};

/** Số tiền đã thu VƯỢT công nợ, cần hoàn lại khách (0 nếu không thu thừa). */
export const overpaidAmount = (debitAmount?: number | null): number => {
  const debit = Number(debitAmount ?? 0);
  return debit > 0 ? debit : 0;
};

/** Đơn còn tiền để thu qua OnePay hay không. */
export const hasOutstandingDebt = (debitAmount?: number | null): boolean =>
  outstandingAmount(debitAmount) > 0;
